import PropTypes from 'prop-types';

// Shared layout-related defaults
export const DEFAULT_HEADER_HEIGHT = 65;

export const headerBoundsPropType = PropTypes.shape({
  left: PropTypes.number,
  right: PropTypes.number,
  top: PropTypes.number,
  bottom: PropTypes.number,
  width: PropTypes.number,
  height: PropTypes.number,
});
